import {
  CreateOmitBaseEntityKeys,
  IBaseEntity,
  UpdateOmitBaseEntityKeys,
} from "../system/BaseEntity";
import {
  INurtureCampaignCondition,
  NurtureCampaignConditionCreate,
  NurtureCampaignConditionUpdate,
} from "./NurtureCampaignCondition";

export interface SendTestEmail {
  email: string;
  nurtureCampaignId: string;
  ruleId: string;
}

export enum NurtureAction {
  None,
  SendEmail,
}

export interface INurtureCampaignRule extends IBaseEntity {
  enabled: boolean;
  name: string;
  delay: number;
  action: NurtureAction;
  subject: string;
  conditions: INurtureCampaignCondition[];
  content: string;
  enableButton: boolean;
  buttonText: string;
  buttonUrl: string;
  nurtureCampaignId: string;
  nextRuleId?: string;
}

export interface NurtureCampaignRuleCreate
  extends Omit<INurtureCampaignRule, CreateOmitBaseEntityKeys | "conditions"> {
  conditions: NurtureCampaignConditionCreate[];
}

export interface NurtureCampaignRuleUpdate
  extends Omit<INurtureCampaignRule, UpdateOmitBaseEntityKeys | "conditions"> {
  conditions: NurtureCampaignConditionUpdate[];
}
